<template>
  <div class="p-6 bg-indigo-800 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-2xl">
      <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('dashboard')">
          SAPBKPP
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        <span class="text-white font-medium">Registrasi User Baru</span>
      </h1>

      <div v-if="!isRegistered" class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
        <form @submit.prevent="submitRegister">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input
              v-model="form.first_name"
              :error="form.errors.first_name"
              class="pr-6 pb-8 w-full lg:w-1/2"
              label="Nama Depan" />
            <text-input
              v-model="form.last_name"
              :error="form.errors.last_name"
              class="pr-6 pb-8 w-full lg:w-1/2"
              label="Nama Belakang" />
            <text-input
              v-model="form.email"
              :error="form.errors.email"
              class="pr-6 pb-8 w-full lg:w-1/2"
              label="Email" />
            <text-input
              v-model="form.bank_acc_number"
              :error="form.errors.bank_acc_number"
              class="pr-6 pb-8 w-full lg:w-1/2"
              label="Nomor Rekening Bank" />
            <text-input
              v-model="form.password"
              :error="form.errors.password"
              class="pr-6 pb-8 w-full lg:w-1/2"
              type="password"
              autocomplete="new-password"
              label="Password" />
            <text-input
              v-model="form.password_confirmation"
              :error="form.errors.password_confirmation"
              class="pr-6 pb-8 w-full lg:w-1/2"
              type="password"
              autocomplete="confirm-password"
              label="Confirm Password" />
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap justify-end items-center">
            <div class="pr-6 pt-2">
              <img :src="captchaImgUrl">
              <a href="#" @click.prevent="refreshCaptcha"><span class="underline text-indigo-500">refresh image</span></a>
            </div>
            <div class="pr-6 pb-8">
              <text-input
                v-model="form.captcha"
                :error="form.errors.captcha"
                label="Inputkan kode sesuai gambar" />
            </div>
            <div class="pb-2">
              <loading-button
                :loading="form.processing"
                class="btn-indigo"
                type="submit">
                Submit
              </loading-button>
            </div>
          </div>
        </form>
      </div>
      <div v-else class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <span class="my-2">Registrasi user berhasil dilakukan, silahkan cek email anda dan pastikan klik pada link yang dikirimkan untuk memverifikasi email</span>
          <span class="my-2">Anda dapat melakukan pengisian data mahasiswa dan melakukan pengajuan beasiswa jika email anda telah berhasil terverifikasi</span>
          <span class="my-2 text-2xl">Email yang anda daftarkan: {{ emailRegistered }}</span>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap justify-end items-center">
          <div>
            <inertia-link class="btn-indigo" :href="route('dashboard')">
              <span>Masuk ke situs</span>
            </inertia-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create User' },
  components: {
    LoadingButton,
    TextInput,
  },
  remember: 'form',
  props: {
    isRegistered: {
      type: Boolean,
      default: false,
    },
    emailRegistered: {
      type: String,
      default: null,
    },
    captchaImgUrl: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
        bank_acc_number: null,
        captcha: null,
      }),
    }
  },
  methods: {
    submitRegister () {
      this.form.post(this.route('register.submit'), {
        onFinish: () => this.form.reset('captcha'),
      })
    },
    refreshCaptcha () {
      this.$inertia.reload()
    },
  },
}
</script>
